import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import {
    HeadingLarge,
    Subheading,
    BodyText,
} from "~/components/.base/headings";
import { WhiteButton } from "~/components/.base/buttons";
import { SearchForm } from "~/components/.base/inputs";
import { Grid, Row, Col, FlexBox } from "~/components/.base/containers";
import SearchIcon from "~/images/icons/search.svg";
import MapIcon from "~/images/icons/map.svg";
import girlfeedingguy from "~/images/locations/girlfeeding_guy.png";
import "./LocationHero.scss";

const LocationHero = () => {
    const [zipCode, setZipCode] = useState("");
    const [zipWarning, setZipWarning] = useState("");
    const handleSearch = (e) => {
        e.preventDefault();
        if (zipCode.length === 5) {
            window.location.href = `/locations/search?q=${zipCode}&dist=15`;
        } else {
            setZipWarning("Please enter a valid ZIP code");
        }
    };
    useEffect(() => {
        const states = document.querySelectorAll(".map-cont .cml-state");
        states.forEach((state) => {
            state.addEventListener("mouseover", (e) => {
                state.style.fill = "#d4212c";
                let stateText = document.querySelector(
                    `text.annotation#${e.target.id}`
                );
                if (stateText) {
                    stateText.style.fill = "#fff";
                }
            });
            state.addEventListener("mouseleave", (e) => {
                state.style.fill = "#FFEDEE";
                let stateText = document.querySelector(
                    `text.annotation#${e.target.id}`
                );
                if (stateText) {
                    stateText.style.fill = "#5C6566";
                }
            });
            state.addEventListener("click", (e) => {
                if (window && e.target.id) {
                    window.location.href = `/locations/search?state=${e.target.id}`;
                }
            });
        });
        const annotations = document.querySelectorAll(".map-cont .annotation");
        annotations.forEach((a) => {
            a.addEventListener("mouseover", (e) => {
                a.style.fill = "#fff";
                let stateBody = document.querySelector(
                    `.cml-state#${e.target.dataset.state}`
                );
                if (stateBody) {
                    stateBody.style.fill = "#d4212c";
                }
            });
            a.addEventListener("click", (e) => {
                if (window && e.target.dataset.state) {
                    window.location.href = `/locations/search?state=${e.target.dataset.state}`;
                }
            });
        });
    }, []);
    return (
        <Grid className="location-hero">
            <Row>
                <Col size={1} pd="2.5rem" className="search-form">
                    <HeadingLarge md="0 0 2.5rem">
                        <span className="red">Our</span>
                        <br />
                        Locations
                    </HeadingLarge>
                    <BodyText md="0 0 3.5rem">
                        Browse for our locations around the United States,
                        <br />
                        or search by zip code
                    </BodyText>
                    {zipWarning.length ? (
                        <BodyText color="#d4212c" md="0 0 1rem 30px">
                            {zipWarning}
                        </BodyText>
                    ) : null}
                    <form onSubmit={handleSearch}>
                        <SearchForm md="0 0 .75rem">
                            <input
                                placeholder="Search by ZIP code"
                                type="number"
                                min="0"
                                max="99999"
                                value={zipCode}
                                onChange={(e) => setZipCode(e.target.value)}
                            />
                            <button type="submit">
                                <SearchIcon />
                            </button>
                        </SearchForm>
                    </form>
                    <FlexBox align="center" className="or">
                        <Subheading>Or</Subheading>
                        <div className="bar" />
                    </FlexBox>
                    <Link className="state-list-link" to="#location-list">
                        <WhiteButton height="50px" md="0 0 .75rem">
                            Search by state list
                        </WhiteButton>
                    </Link>
                    <img
                        src={girlfeedingguy}
                        alt="girl feeding guy"
                        className="girl-feeding-guy"
                        style={{ margin: "1rem 0 1rem -2.5rem" }}
                    />
                </Col>
                <Col className="map-cont" size={2} pd="2rem 4rem">
                    <MapIcon />
                </Col>
            </Row>
        </Grid>
    );
};
export default LocationHero;
